import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import setTableColumns from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetTableColumns";
import setVisibleColumnNames from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetVisibleColumnNames";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { AttributeTypeFacetModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductListProductContext from "@insite/content-library/Widgets/ProductList/ProductListProductContext";
import ProductListProductImage, {
    ProductListProductImageStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Info from "@insite/mobius/Icons/Info";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductQuantityBreakPricingTable from "@MasterBluePrint/Components/ProductQuantityBreakPricingTable";
import Tooltip from "@MasterBluePrint/MobiusOverrides/Tooltip/Tooltip";
import ProductPrice, { ProductPriceStyles } from "@MasterBluePrint/Overrides/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@MasterBluePrint/Overrides/Components/ProductQuantityBreakPricing";
import { ProductCardSelections } from "@MasterBluePrint/Overrides/Widgets/ProductList/ProductCardSelections";
import ProductListActions from "@MasterBluePrint/Overrides/Widgets/ProductList/ProductListActions";
import ProductListHazmatIcon from "@MasterBluePrint/Overrides/Widgets/ProductList/ProductListHazmatIcon";
import ProductListProductInformation from "@MasterBluePrint/Overrides/Widgets/ProductList/ProductListProductInformation";
import { FormattedCommaSeparatedValue } from "@MasterBluePrint/Services/FormattedValueService";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import sortBy from "lodash/sortBy";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


interface OwnProps {
    products: ProductModel[];
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    productInfosByProductId: state.pages.productList.productInfosByProductId,
    attributeTypeFacets: getProductListDataViewProperty(state, "attributeTypeFacets"),
    brandFacets: getProductListDataViewProperty(state, "brandFacets"),
    productLineFacets: getProductListDataViewProperty(state, "productLineFacets"),
    visibleColumnNames: state.pages.productList.visibleColumnNames,
    tableColumns: state.pages.productList.tableColumns,
    pageCategoryId: state.pages.productList.productFilters.pageCategoryId,
});

const mapDispatchToProps = {
    setTableColumns,
    setVisibleColumnNames,
};

type Props = ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ProductCardSelections &
    OwnProps;

export interface ProductListTableStyles {
    wrapper?: InjectableCss;
    dataTable?: DataTableProps;
    descriptionHeader?: DataTableHeaderProps;
    attributesHeader?: DataTableHeaderProps;
    availabilityHeader?: DataTableHeaderProps;
    priceHeader?: DataTableHeaderProps;
    unitOfMeasureHeader?: DataTableHeaderProps;
    actionsHeader?: DataTableHeaderProps;
    descriptionCell?: DataTableCellProps;
    partCell?: DataTableCellProps;
    gridContainer?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    productImageStyles?: ProductListProductImageStyles;
    attributesCell?: DataTableCellProps;
    availabilityCell?: DataTableCellProps;
    availabilityStyles?: ProductAvailabilityStyles;
    priceCell?: DataTableCellProps;
    productPrice?: ProductPriceStyles;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    unitOfMeasureCell?: DataTableCellProps;
    unitOfMeasureText?: TypographyPresentationProps;
    actionsCell?: DataTableCellProps;
    sponsoredText?: TypographyPresentationProps;
    priceStyleCustom?: InjectableCss;
    availabilityStylesCustom?: InjectableCss;
    minQtyLabel?: InjectableCss;
    minQtyValue?: InjectableCss;
    nonCancellableNonReturnableContainer?: InjectableCss;
    nonCancellableNonReturnableText?: InjectableCss;
    nonCancellableNonReturnableAnchor?: InjectableCss;
    leadTimeContainer?: InjectableCss;
    leadTimeLabel?: InjectableCss;
    parentProductInfomationLabel?: InjectableCss;
    leadTimeValue?: InjectableCss;
    tooltipStyles?: InjectableCss;
    totalAvilableFutureContainer?: InjectableCss;
    totalAvilableFutureLabel?: InjectableCss;
    totalAvilableFutureValue?: InjectableCss;
    thead?: InjectableCss;
}

export const actionsStyles: ProductListTableStyles = {
    wrapper: {
        css: css`
        `,
    },
    dataTable: {
        css: css`
            margin-bottom: 1.875rem;
            thead {
                tr {
                    th {
                        min-height:2.0625rem !important;
                        height: unset;
                        padding-top: .5rem;
                        padding-bottom: .5rem;
                        line-height: 1.2rem;
                    }
                }
               
            }

            td {
                vertical-align: top;
                border: 1px solid ${themeColors.colorBorderBrands};
                padding: .625rem;
                position: relative;
                @media screen and (max-width: 1379px) {
                    &:nth-child(1) {
                        min-width: 3rem;
                        > div {
                            min-width: 3rem;
                        }
                     }
                }
                &:last-child {
                    padding-top: 0;
                    padding-bottom: 0;
                }
                 .digitalProductStyle {
                    position: relative !important;;
                    color: #002554 !important;
                    font-size: 0.9rem !important;
                    width: 7rem !important;
                    font-weight: 900 !important;
                    font-family: Roboto !important;
               }                
            }
        `,
    },
    gridContainer: {
        gap: 0,
        css: css`
            padding: 0;
            min-width: 7.5rem; /* prevent overlap with second column */
            box-sizing: border-box;
            @media screen and (min-width: 1400px) {
                .mw-130 {
                    max-width: 8.125rem;
                }
            }
        `,
    },
    leftColumnGridItem: {
        width: [4, 4, 4, 3, 3],
        css: css`
            padding-right: .75rem;
            flex-direction: column;
        `,
    },
    rightColumnGridItem: {
        width: [8, 8, 8, 9, 9],
        css: css`
            flex-direction: column;
        `,
    },
    productImageStyles: {
        compareCheckbox: {
            css: css`
                align-self: start;
                padding-top: .9375rem;
            `,
        },
    },
    actionsHeader: {
        css: css`
            right: 0;
            width: 10rem;
            min-width: 10rem;
            background-clip: padding-box;
            color: ${themeColors.colorCharcoalGrey};
            font-family: Roboto, sans-serif;
            font-size: ${themeFontSizes.size15};
            font-weight: 500 !important;
            letter-spacing: .011rem;
            line-height: 1.4375rem;
            background-color: ${themeColors.colorBorderBrands};
            height: auto;
            border: none;
            @media screen and (min-width: 1280px) {
                max-width: 10rem;
               
        `,
    },
    descriptionCell: {
        css: css`
            white-space: normal;
        `,
    },
    partCell: {
        css: css`
            white-space: normal;
        `,
    },
    attributesCell: {
        css: css`
            white-space: normal;
        `,
    },
    availabilityCell: {
        css: css`
            white-space: normal;
        `,
    },
    availabilityStyles: {
        messageText: {
            css: css`
                white-space: normal;
                color: ${themeColors.colorCharcoalGrey};
                font-family: Roboto;
                font-size: ${themeFontSizes.size14};
                letter-spacing: 0;
                line-height: 1.25rem;
            `,
        },
    },
    availabilityStylesCustom: {
        css: css`
            white-space: normal;
            color: ${themeColors.colorCharcoalGrey};
            font-family: Roboto;
            font-size: ${themeFontSizes.size14};
            letter-spacing: 0;
            line-height: .9375rem;
            max-width: 5.625rem;
            display: inline-block;
            div {
                margin-top: 0;
                max-width: 5.625rem;
            }
            a, span {
                white-space: normal;
                color: ${themeColors.colorCharcoalGrey};
                font-family: Roboto;
                font-size: ${themeFontSizes.size14};
                letter-spacing: 0;
                line-height: 1.25rem;
                display: inline-block;
            }
        `,
    },
    actionsCell: {
        css: css`
            right: 0;
            width: 10rem;
            background-color: inherit;
            background-clip: padding-box;
            min-width: 11.75rem;
            button {
                margin-top: .250625rem !important;
                margin-bottom: .625rem !important;
            }
            .input-container {
                input {
                    width: 10.5rem !important;
                    min-width: 10.5rem !important;
                    color: #333F47 !important;
                    font-family: Roboto;
                    font-size: .875rem !important;
                    letter-spacing: .01rem;
                }
            }
        `,
    },
    sponsoredText: {
        css: css`
            margin-bottom: .31250625rem;
            font-size: .9em;
            opacity: .5;
        `,
    },
    descriptionHeader: {
        css: css`
            min-width: 9.0625rem;
            color: ${themeColors.colorCharcoalGrey};
            font-family: Roboto, sans-serif;
            font-size: ${themeFontSizes.size15};
            font-weight: 500 !important;
            letter-spacing: .011rem;
            line-height: 1.4375rem;
            background-color: ${themeColors.colorBorderBrands};
            min-height: 2.0625rem;
            max-height: auto;
            border: none;
            width: auto;
            @media screen and (max-width: 1379px) {
                &:nth-child(1) {
                    min-width: 3rem;
                    > div {
                        min-width: 3rem;
                    }
                 }
            }
            
        `,
    },
    availabilityHeader: {
        css: css`
            min-width: 7.25rem;
            color: ${themeColors.colorCharcoalGrey};
            font-family: Roboto, sans-serif;
            font-size: ${themeFontSizes.size15};
            font-weight: 500 !important;
            letter-spacing: .011rem;
            line-height: 1.4375rem;
            background-color: ${themeColors.colorBorderBrands};
            height: 2.0625rem;
            border: none;
            width: auto;
            
            @media screen and (max-width: 1400px) {
                white-space: unset;
            }
        `,
    },
    priceHeader: {
        css: css`
            color: ${themeColors.colorCharcoalGrey};
            font-family: Roboto, sans-serif;
            font-size: ${themeFontSizes.size15};
            font-weight: 500 !important;
            letter-spacing: .011rem;
            line-height: 1.4375rem;
            background-color: ${themeColors.colorBorderBrands};
            height: 2.0625rem;
            border: none;
            width: auto;
           
            @media screen and (min-width: 1400px) {
                max-width: 6.875rem;
            }
        `,
    },
    priceStyleCustom: {
        css: css`
            color: ${themeColors.colorRed};
            font-family: Roboto, sans-serif;
            font-size: ${themeFontSizes.size14};
            font-weight: bold;
            letter-spacing: -.017rem;
            line-height: 1.0625rem;
            display: inline-block;
            width: auto;
            @media (min-width: 1400px) {
                width: max-content;
                white-space: normal;
                text-align: right;
                max-width: 6.875rem;
                float: right;

                &.long-length + .price-unit {
                    clear: both;
                }   
            }
            &:after {
                clear: both;
                content: '';
                display: block;
            }
            section {
                margin-bottom: 0;
                text-align: left;
                width: auto;
                display: inline-block;
                clear: right;
                margin-right: .31250625rem;
                span {
                    margin-bottom: 0 !important;
                    margin-right: .31250625rem;
                }
                @media (min-width: 1400px) {
                    &.long-length + .price-unit {
                        clear: both;
                    }

                    span {
                        position: relative;
                        top: .0625rem;
                    }
                }
                @media (max-width: 1399px) {
                    float: left;
                }
            }
            span {
                color: ${themeColors.colorRed};
                font-family: Roboto, sans-serif;
                font-size: ${themeFontSizes.size14} !important;
                font-weight: bold !important;
                letter-spacing: -.27px !important;
                line-height: 1.25rem !important;
                display: inline-block;
                float: left;
                clear: left;
                text-align: right;
                width: 100%;
            }
            .price-unit {
                color: ${themeColors.colorSelectBox};
                font-family: Roboto;
                font-size: .875rem;
                letter-spacing: .003rem
                line-height: 1.5rem;
                text-transform: lowercase;
                float: right;
                clear: none;
                width: auto;
                margin-right: .31250625rem;
                @media (min-width: 1400px) {
                    text-align: right;
                    width: auto;
                    margin-right: .31250625rem;
                    display: inline-block;
                }
            }
        `,
    },
    leadTimeContainer: {
        css: css`
            font-weight: 600;
            font-size: .875rem !important;
            margin-bottom: .2em;
            font-family: 'Roboto', sans-serif;
            display: block;
            margin-top: .6rem;
        `,
    },
    leadTimeLabel: {
        css: css`
            margin-right: .5rem;    
            display: block;
            font-size: .875rem !important;
            color: #002554;
            font-weight: 600;
            white-space: nowrap;
        `,
    },
    parentProductInfomationLabel: {
        css: css`
            margin-right: .5rem;    
            display: block;
            font-size: .875rem !important;
            color: #002554;
            font-weight: 600;
        `,
    },
    leadTimeValue: {
        css: css`
            color: #333F48;
            font-family: 'Roboto', sans-serif;
            font-weight: 400;
            display: block;
            font-size: .875rem !important;
            letter-spacing: 0;
            line-height: 1.25rem;
            span {
                margin-left: 1rem;
            }
        `,
    },

    minQtyLabel: {
        css: css`
            margin-right: .31250625rem;
            font-style: italic;
            margin-left: .625rem;
            margin-bottom: .6rem;
            position: relative;
            display: inline-block;
            color: #333F48;
            font-family: 'Roboto', sans-serif;
            font-size: .875rem;
            letter-spacing: 0;
            line-height: 1.5rem;
        `,
    },
    minQtyValue: {
        css: css`
            color: #333F48;
            font-family: 'Roboto', sans-serif;
            font-weight: 400;
            font-style: italic;
            font-size: .875rem;
        `,
    },
    nonCancellableNonReturnableContainer: {
        css: css`
            font-weight: 600;
            font-size: .85rem;
            margin-bottom: .2em;
            text-align: center;
            max-width: 10.375rem;
            color: #333F48;

            @media (min-width: 1400px) {
                max-width: 11.75rem;
                margin-bottom: .625rem;
                white-space: normal;
            }
        `,
    },
    nonCancellableNonReturnableText: {
        css: css`
            color: #333F48;
            font-family: 'Roboto', sans-serif;
            font-size: .875rem;
            font-style: italic;
            letter-spacing: .003rem
            line-height: 1.1875rem;
            text-align: center;
            font-weight: normal;
        `,
    },
    nonCancellableNonReturnableAnchor: {
        css: css`
            color: #333F48;
            font-size: .875rem;
            font-style: italic;
            letter-spacing: .003rem
            line-height: 1.1875rem;
            text-align: center;
            font-family: 'Roboto', sans-serif;
            font-weight: normal;
            &:hover {
                text-decoration: underline !important;
                color: #333F48 !important;
            }
            span {
                color: #333F48;
                &:hover {
                    text-decoration: underline !important;
                    color: #333F48 !important;
                }
            }
        `,
    },
    tooltipStyles: {
        css: css`
            padding:.3rem .5rem;
            width: auto;
            color: #fff;
            margin: 0 0 1rem;
        `,
    },
    totalAvilableFutureContainer: {
        css: css`
            font-weight: 600;
            font-size: .875rem;
            margin-bottom: .2em;
            margin-top: .6rem;
        `,
    },
    totalAvilableFutureLabel: {
        css: css`
            color: #002554;
            font-family: 'Roboto', sans-serif;
            font-weight: 600;
            display: block;
            font-size: .875rem !important;
            display: inline-block;
            margin-right: 0.5rem;
            white-space: normal;
        `,
    },
    totalAvilableFutureValue: {
        css: css`
            color: #333F48;
            font-family: 'Roboto', sans-serif;
            font-weight: 400;
            display: block;
            font-size: .875rem !important;
            display: inline-block;
            white-space: normal;
        `,
    },
};

const styles = actionsStyles;

const ProductListTable: FC<Props> = ({
    products,
    productSettings,
    productInfosByProductId,
    attributeTypeFacets,
    brandFacets,
    productLineFacets,
    visibleColumnNames,
    tableColumns,
    pageCategoryId,
    setTableColumns,
    setVisibleColumnNames,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showShippingRestrictionIcon,
    showHazardousGoodIcon,
    displayQtyBreakPricingInTable,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}) => {
    useEffect(() => {
        if (!attributeTypeFacets?.length && !brandFacets?.length && !productLineFacets?.length) {
            setTableColumns({ tableColumns: [] });
            setVisibleColumnNames({ visibleColumnNames: [] });
            return;
        }

        const columns = attributeTypeFacets
            ? sortBy(
                attributeTypeFacets,
                o => o.sortOrder,
                o => o.name,
            )
            : [];
        if (brandFacets?.length) {
            columns.push({
                attributeTypeId: "",
                name: "Brand",
                nameDisplay: "",
                sortOrder: 0,
                attributeValueFacets: [],
            });
        }

        if (productLineFacets?.length) {
            columns.push({
                attributeTypeId: "",
                name: "Product Line",
                nameDisplay: "",
                sortOrder: 0,
                attributeValueFacets: [],
            });
        }

        setTableColumns({ tableColumns: columns });
        setVisibleColumnNames({ visibleColumnNames: columns?.slice(0, 3).map(o => o.name) || [] });
    }, [pageCategoryId]);

    const productListRows = products.map((product, idx) => {

        const productInfo = productInfosByProductId[product.id];
        if (!productInfo) {
            return;
        }
        const productContext: ProductContextModel = {
            product,
            productInfo,
        };

        const unitOfMeasure = productContext.product.unitOfMeasures?.find(
            o => o.unitOfMeasure === productContext.productInfo.unitOfMeasure,
        );

        return (
            <ProductListProductContext product={product} key={product.id} idx={idx}>
                <DataTableRow key={product.id} data-test-selector={`productListProductCard${product.id}`} className="table-row">
                    <DataTableCell {...styles.descriptionCell}>
                        <GridContainer {...styles.gridContainer}>
                            {product.isSponsored && (
                                <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
                            )}
                            <ProductListProductImage
                                showImage={true}
                                showCompare={false}
                                extendedStyles={styles.productImageStyles}
                                showImageBadge={showImageBadges}
                                showTextBadge={showTextBadges}
                            /> </GridContainer>
                    </DataTableCell>
                    <DataTableCell {...styles.partCell}>
                        <GridContainer {...styles.gridContainer} className="mw-130">
                            <ProductListProductInformation
                                showAttributes={false}
                                showAvailability={false}
                                showBrand={false}
                                showPartNumbers={showPartNumbers}
                                showTitle={false}
                                showImageBadges={false}
                                maxImageBadges={maximumNumberOfImageBadges}
                                showTextBadges={false}
                                maxTextBadges={maximumNumberOfTextBadges}
                                showOurPartMfrPartLabels={false}
                                showMfrPart={false}
                            />
                            <ProductListHazmatIcon
                                showShippingRestrictionIcon={showShippingRestrictionIcon}
                                showHazardousGoodIcon={showHazardousGoodIcon}
                            />
                            <ProductListProductImage
                                showImage={false}
                                showCompare={false}
                                extendedStyles={styles.productImageStyles}
                            />
                        </GridContainer>
                    </DataTableCell>
                    <DataTableCell {...styles.partCell}>
                        <ProductListProductInformation
                            showAttributes={false}
                            showAvailability={false}
                            showBrand={false}
                            showPartNumbers={showPartNumbers}
                            showTitle={false}
                            showImageBadges={false}
                            maxImageBadges={maximumNumberOfImageBadges}
                            showTextBadges={false}
                            maxTextBadges={maximumNumberOfTextBadges}
                            showOurPartMfrPartLabels={false}
                            showOurPart={false}
                        />
                    </DataTableCell>
                    <DataTableCell  {...styles.attributesCell}>
                        <ProductListProductInformation
                            showAttributes={false}
                            showAvailability={false}
                            showBrand={showBrand}
                            showPartNumbers={false}
                            showTitle={false}
                        />
                    </DataTableCell>
                    <DataTableCell  {...styles.attributesCell}>
                        <ProductListProductInformation
                            showAttributes={false}
                            showAvailability={false}
                            showBrand={false}
                            showPartNumbers={false}
                            showTitle={showTitle}
                        />
                    </DataTableCell>
                    <DataTableCell {...styles.availabilityCell}>
                        {!product.isVariantParent ?
                            (
                                <>
                                    <Typography {...styles.availabilityStylesCustom}>
                                        <ProductContextAvailability extendedStyles={styles.availabilityStyles} />
                                    </Typography>
                                    {product.properties.totalAvailableFuture &&
                                        (
                                            <StyledWrapper {...styles.totalAvilableFutureContainer}>
                                                <Typography {...styles.totalAvilableFutureLabel}>
                                                    {siteMessage("avilableFetureLabel") || translate("Total Avilable Future:")}
                                                </Typography>
                                                <Typography {...styles.totalAvilableFutureValue}>
                                                    {FormattedCommaSeparatedValue(product.properties.totalAvailableFuture)}
                                                </Typography>
                                            </StyledWrapper>
                                        )}
                                    {product.properties.averageLeadTime &&
                                        (
                                            <StyledWrapper {...styles.leadTimeContainer}>
                                                <Typography {...styles.leadTimeLabel}>
                                                    {siteMessage("leadtimelabel") || translate("Manufacturer Lead Time:")}
                                                </Typography>
                                                <Typography {...styles.leadTimeValue}>
                                                    {product.properties.averageLeadTime} {translate("Days")}
                                                </Typography>
                                            </StyledWrapper>
                                        )}</>

                            ) : (<>
                                <StyledWrapper>
                                    <Typography {...styles.parentProductInfomationLabel}>
                                        {siteMessage("ParentProduct_PLP_Availability_InfoText")}
                                    </Typography>
                                </StyledWrapper></>)}
                    </DataTableCell>
                    <DataTableCell {...styles.priceCell}>
                        <Typography {...styles.priceStyleCustom} className="product-price">
                            <ProductPrice
                                product={productContext}
                                showLabel={false}
                                showUnitOfMeasure={false}
                                showPack={false}
                                showSavingsAmount={productSettings.showSavingsAmount}
                                showSavingsPercent={productSettings.showSavingsPercent}
                                extendedStyles={styles.productPrice}
                                hideVat={true}
                            />
                            <Typography {...styles.unitOfMeasureText} className="price-unit">
                                {unitOfMeasure?.description || unitOfMeasure?.unitOfMeasureDisplay}
                            </Typography>
                            <ProductListProductInformation
                                showAttributes={false}
                                showAvailability={false}
                                showBrand={false}
                                showPartNumbers={false}
                                showTitle={false}
                                showImageBadges={showImageBadges}
                                maxImageBadges={maximumNumberOfImageBadges}
                                showTextBadges={showTextBadges}
                                maxTextBadges={maximumNumberOfTextBadges}
                            />

                        </Typography >
                        {displayQtyBreakPricingInTable ? <ProductQuantityBreakPricingTable extendedStylesTable={styles.quantityBreakPricing} /> : <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />}
                    </DataTableCell >
                    <DataTableCell {...styles.actionsCell}>
                        <ProductListActions
                            product={product}
                            showAddToList={showAddToList}
                            showPrice={false}
                            displayQtyBreakPricingInTable
                            showImageBadges={false}
                            showTextBadges={false}
                        />
                    </DataTableCell>
                </DataTableRow >
            </ProductListProductContext >
        );
    });

    return (
        <StyledWrapper {...styles.wrapper}>
            <DataTable {...styles.dataTable}>
                <DataTableHead  {...styles.thead}>
                    <DataTableHeader {...styles.descriptionHeader}></DataTableHeader>
                    <DataTableHeader {...styles.descriptionHeader}>{translate("Our Part #")}</DataTableHeader>
                    <DataTableHeader {...styles.descriptionHeader}>{translate("Mfr Part #")}</DataTableHeader>
                    <DataTableHeader {...styles.descriptionHeader}>{translate("Brand")}</DataTableHeader>
                    <DataTableHeader {...styles.descriptionHeader}>{translate("Product")}</DataTableHeader>
                    <DataTableHeader {...styles.availabilityHeader}>{translate("Availability")}</DataTableHeader>
                    <DataTableHeader {...styles.priceHeader}>{translate("Price")}</DataTableHeader>
                    <DataTableHeader {...styles.actionsHeader}>{translate("Quantity")}</DataTableHeader>
                </DataTableHead>
                <DataTableBody>{productListRows}</DataTableBody>
            </DataTable>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductListTable);